import styled from '@emotion/styled';
import {
    GetTextAnswerQuery,
    GetTextAnswersByProductQuery,
} from '@graphql/generated/graphql';
import { StateResultsProvided } from 'react-instantsearch-core';

import TextAnswerCard from './textAnswerCard';

/* -------------------------------------------------------------------------- */
/*                                    TYPE                                    */
/* -------------------------------------------------------------------------- */

type TextAnswer = NonNullable<GetTextAnswerQuery['textAnswer']>;

export type PropsType = {
    textAnswers: ExtractCollection<
        GetTextAnswersByProductQuery,
        'products',
        'Text_answers'
    >;
    searchResults?: StateResultsProvided<TextAnswer>['searchResults'];
};

/* -------------------------------------------------------------------------- */
/*                                   STYLES                                   */
/* -------------------------------------------------------------------------- */
const Background = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
`;

const Div = styled.div`
    width: 100%;
`;

const Divider = styled.hr`
    border-top: 1px solid ${(props) => props.theme.palette.divider};
    width: 100%;
`;

/* -------------------------------------------------------------------------- */
/*                                  COMPONENT                                 */
/* -------------------------------------------------------------------------- */
const TextAnswersArray = ({ textAnswers, searchResults }: PropsType) => {
    return textAnswers ? (
        <Background className='text_answers_array'>
            {textAnswers.map((textAnswer, index) => {
                const isLastItem = index === textAnswers.length - 1;

                return (
                    <Div key={index}>
                        <TextAnswerCard
                            key={textAnswer!.id}
                            textAnswer={textAnswer!}
                            index={index}
                            searchResults={searchResults}
                        />
                        {!isLastItem && <Divider />}
                    </Div>
                );
            })}
        </Background>
    ) : null;
};

export default TextAnswersArray;
